export default {"src":"https://fishbrain.com/_next/static/media/mississippi.2efd25a0.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};